// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// import "./App.css"; // Reuse existing CSS for consistency

// function AdminPage() {
//   const navigate = useNavigate();
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const ServerUrl = "https://voice-sample.tpvai.com/b/";

//   const fetchUsers = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`${ServerUrl}api/users`);
//       if (response.status === 200) {
//         setUsers(response.data);
//       } else {
//         throw new Error("Failed to fetch users");
//       }
//     } catch (error) {
//       Swal.fire("Error", error.message || "Failed to fetch users", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateRole = async (email, currentRole) => {
//     const newRole = currentRole === "user" ? "admin" : "user";
//     try {
//       const response = await axios.post(`${ServerUrl}api/updateuser`, {
//         email,
//         role: newRole
//       });
//       if (response.status === 200) {
//         Swal.fire("Success", "User role updated successfully", "success");
//         setUsers(users.map(user => 
//           user.email === email ? { ...user, role: newRole } : user
//         ));
//       } else {
//         throw new Error("Failed to update role");
//       }
//     } catch (error) {
//       Swal.fire("Error", error.message || "Failed to update role", "error");
//     }
//   };

//   const resetPassword = (email) => {
//     // Blank function for now
//     console.log(`Reset password requested for ${email}`);
//     Swal.fire("Info", "Reset password function not implemented yet", "info");
//   };

//   const handleBack = () => {
//     navigate("/audio"); // Assuming "/audio" is the route for Audiopage
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   return (
//     <div className="w-screen h-screen bg-gradient-to-r from-indigo-500 via-purple-600 to-pink-500 flex justify-center items-center p-4">
//       <div className="bg-white p-6 sm:p-8 md:p-12 rounded-xl shadow-xl space-y-6 w-full max-w-5xl">
//         <h1 className="text-2xl sm:text-3xl font-semibold text-center mb-6 text-gray-800">Admin Panel - User Management</h1>
//         <button onClick={handleBack} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
//           Back to Audio Page
//         </button>

//         {loading ? (
//           <div className="loader mx-auto"></div>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="min-w-full bg-white border border-gray-300">
//               <thead>
//                 <tr className="bg-gray-200 text-gray-700">
//                   <th className="py-2 px-4 border-b">ID</th>
//                   <th className="py-2 px-4 border-b">Email</th>
//                   <th className="py-2 px-4 border-b">Role</th>
//                   <th className="py-2 px-4 border-b">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {users.map((user) => (
//                   <tr key={user._id} className="text-gray-700 hover:bg-gray-100">
//                     <td className="py-2 px-4 border-b">{user._id}</td>
//                     <td className="py-2 px-4 border-b">{user.email}</td>
//                     <td className="py-2 px-4 border-b">{user.role}</td>
//                     <td className="py-2 px-4 border-b flex space-x-2">
//                       <button
//                         onClick={() => updateRole(user.email, user.role)}
//                         className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600 text-sm"
//                       >
//                         Update Role
//                       </button>
//                       <button
//                         onClick={() => resetPassword(user.email)}
//                         className="bg-gray-500 text-white px-3 py-1 rounded hover:bg-gray-600 text-sm"
//                       >
//                         Reset Password
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default AdminPage;


// user register
import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./App.css";

function AdminPage() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const ServerUrl = "https://voice-sample.tpvai.com/b/";

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${ServerUrl}api/users`);
      if (response.status === 200) {
        setUsers(response.data);
      } else {
        throw new Error("Failed to fetch users");
      }
    } catch (error) {
      Swal.fire("Error", error.message || "Failed to fetch users", "error");
    } finally {
      setLoading(false);
    }
  };

  const updateRole = async (email, currentRole) => {
    const newRole = currentRole === "user" ? "admin" : "user";
    try {
      const response = await axios.post(`${ServerUrl}api/updateuser`, {
        email,
        role: newRole,
      });
      if (response.status === 200) {
        Swal.fire("Success", "User role updated successfully", "success");
        setUsers(users.map((user) =>
          user.email === email ? { ...user, role: newRole } : user
        ));
      } else {
        throw new Error("Failed to update role");
      }
    } catch (error) {
      Swal.fire("Error", error.message || "Failed to update role", "error");
    }
  };

  const resetPassword = (email) => {
    console.log(`Reset password requested for ${email}`);
    Swal.fire("Info", "Reset password function not implemented yet", "info");
  };

  const handleBack = () => {
    navigate("/audio"); // Assuming "/audio" is the route for Audiopage
  };

  const handleRegisterUser = async () => {
    const { value: formValues } = await Swal.fire({
      title: "Register New User",
      html:
        '<input id="swal-input1" class="swal2-input" placeholder="Email" type="email">' +
        '<input id="swal-input2" class="swal2-input" placeholder="Password" type="password">' +
        '<select id="swal-input3" class="swal2-select" style="border: 1px solid black;">' +
        '<option value="user">User</option>' +
        '<option value="admin">Admin</option>' +
        "</select>",
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Register",
      preConfirm: () => {
        const email = document.getElementById("swal-input1").value;
        const password = document.getElementById("swal-input2").value;
        const role = document.getElementById("swal-input3").value;

        if (!email || !password || !role) {
          Swal.showValidationMessage("Please fill in all fields");
          return false;
        }
        return { email, password, role };
      },
    });

    if (formValues) {
      try {
        const response = await axios.post(`${ServerUrl}api/register`, {
          email: formValues.email,
          password: formValues.password,
          role: formValues.role,
        });

        if (response.status === 200) {
          Swal.fire("Success", response.data.message || "User registered successfully", "success");
          fetchUsers(); // Refresh the user list after registration
        } else {
          throw new Error("Failed to register user");
        }
      } catch (error) {
        Swal.fire("Error", error.message || "Failed to register user", "error");
      }
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="w-screen h-screen bg-gradient-to-r from-indigo-500 via-purple-600 to-pink-500 flex justify-center items-center p-4">
      <div className="bg-white p-6 sm:p-8 md:p-12 rounded-xl shadow-xl space-y-6 w-full max-w-5xl">
        <h1 className="text-2xl sm:text-3xl font-semibold text-center mb-6 text-gray-800">Admin Panel - User Management</h1>
        <div className="flex space-x-4">
          <button onClick={handleBack} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
            Back to Audio Page
          </button>
          <button onClick={handleRegisterUser} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
            Register User
          </button>
        </div>

        {loading ? (
          <div className="loader mx-auto"></div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-300">
              <thead>
                <tr className="bg-gray-200 text-gray-700">
                  <th className="py-2 px-4 border-b">ID</th>
                  <th className="py-2 px-4 border-b">Email</th>
                  <th className="py-2 px-4 border-b">Role</th>
                  <th className="py-2 px-4 border-b">Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user._id} className="text-gray-700 hover:bg-gray-100">
                    <td className="py-2 px-4 border-b">{user._id}</td>
                    <td className="py-2 px-4 border-b">{user.email}</td>
                    <td className="py-2 px-4 border-b">{user.role}</td>
                    <td className="py-2 px-4 border-b flex space-x-2">
                      <button
                        onClick={() => updateRole(user.email, user.role)}
                        className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600 text-sm"
                      >
                        Update Role
                      </button>
                      <button
                        onClick={() => resetPassword(user.email)}
                        className="bg-gray-500 text-white px-3 py-1 rounded hover:bg-gray-600 text-sm"
                      >
                        Reset Password
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminPage;